import { ActivityType, BuildMethod, GenerateContentStatus } from 'models/Activity';

export interface GenerateItem extends GenerateContentStatus {
    activityId: string;
    activityType: ActivityType;
    taskBuildMethod?: BuildMethod;
    activityOrder: number;
    activityTitle: string;
    mediaContent: string;
    textContent: string;
}

export enum Status {
    CREATED,
    STARTED,
    GENERATED,
    ERRORED,
    APPROVED,
}

export function getStatus(generateContentStatus: GenerateItem): Status {
    if (!!generateContentStatus.dateApproved) {
        return Status.APPROVED;
    } else if (!!generateContentStatus.dateErrored) {
        return Status.ERRORED;
    } else if (!!generateContentStatus.dateGenerated) {
        return Status.GENERATED;
    } else if (!!generateContentStatus.dateGenerateStart) {
        return Status.STARTED;
    } else {
        return Status.CREATED;
    }
}
